
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ParticipantMappingViewModel } from '../../../models/participant-mapping-view-model';
import { Select2OptionData } from 'ng-select2';
import { Subject } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SinkNodeMappingConfigViewModel } from '../../../models/sinknode-mapping-config-view-model';
import { ParticipantService } from '../../../services/participant.service';
import { ToastrService } from 'ngx-toastr';
import { CreateResult } from '../../../models/create-result';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-sink-node-mapping-dialog',
  templateUrl: './sink-node-mapping-dialog.component.html',
  styleUrls: ['./sink-node-mapping-dialog.component.scss']
})
export class SinkNodeMappingDialogComponent implements OnInit {

  @Input() mappedField: ParticipantMappingViewModel;
  @Input() mapDescriptions: SinkNodeMappingConfigViewModel[];
  @Input() sinkNodes: string[];
  @Input() selectedSinkNodes: ParticipantMappingViewModel[];
  @Input() selectedMapDescriptions: SinkNodeMappingConfigViewModel[];

  public submitted: boolean = false;
  public mappedFieldForm: FormGroup;
  public select2options: any = {
    multiple: false,
    width: '100%',
    allowClear: true
  };

  public get isEditing(): boolean {
    return !!this.mappedField?.id;
  }

  public get filteredSinkNodes(): Select2OptionData[] {
    
    const selectedMap = +this.mappedFieldForm.controls['mapDescription'].value;
    const mapDescription = this.mapDescriptions.find(x => x.id === selectedMap);
    const isopPfi = this.mapDescriptions.find(x => x.mapDescription === 'ISO PFI');
    let filtered = [];

    if (mapDescription && mapDescription?.mapDescription === 'ISO PFI') {
      const isoSelected = this.selectedSinkNodes.filter(x => x.mappingId === selectedMap);
      filtered =  this.sinkNodes
      .filter(s => this.mappedField.sinknode === s || !isoSelected.map(x => x.sinknode).includes(s))
      .map(s => ({ id: s.toString(), text: s }));
    } else {
      const isoNodes = this.selectedSinkNodes.filter(x => x.mappingId !== isopPfi.mappingId);
      filtered =  this.sinkNodes
      .filter(s => this.mappedField.sinknode === s || !isoNodes.map(x => x.sinknode).includes(s))
      .map(s => ({ id: s.toString(), text: s }));
    }
    if (!!this.mappedField?.sinknode) {
      filtered.unshift({ id: this.mappedField.sinknode.toString(), text: this.mappedField.sinknode });
    }

    return filtered;
  }

  public get filteredMappedDescriptions(): Select2OptionData[] {
    const isoSelected = this.selectedMapDescriptions.find(x => x.mapDescription === 'ISO PFI');
    const aggregatorSelected = this.selectedMapDescriptions.find(x => x.mapDescription === 'Aggregator');
    let mappedDescriptions = [];

    if (isoSelected === undefined) {
      mappedDescriptions = this.mapDescriptions
      .filter(m => m.mapDescription === 'ISO PFI' || this.mappedField.mappingId === m.id || !this.selectedMapDescriptions.includes(m));
    }

    mappedDescriptions = this.mapDescriptions
      .filter(m => this.mappedField.mappingId === m.id || !this.selectedMapDescriptions.includes(m));
    
    if (aggregatorSelected) {
      mappedDescriptions = mappedDescriptions.filter(x => x.mapDescription !== 'Mapped_ISO' && x.mapDescription !== 'ISO PFI');
    }

    return mappedDescriptions.map(x => ({id: x.id ? x.id.toString() : null, text: x.mapDescription}));
  }

  constructor(private _toastService: ToastrService,
              private _participantService: ParticipantService,
              private _modal: NgbActiveModal,
              private _formBuilder: FormBuilder) {

  }

  public async ngOnInit(): Promise<void> {
    this.mappedFieldForm = this._formBuilder.group({
      mapDescription: [ this.mappedField.mappingId, [Validators.required] ],
      sinkNode: [ this.mappedField.sinknode, [Validators.required] ]
    });
  }

  public async triggerOption(option: 'delete' | 'update' | 'create') {
    debugger;
    this.submitted = true;
    if (!!this.mappedFieldForm.valid) {
      this.syncFormValues();
      this._modal.close({ option: option, data: this.mappedField });
    }
  }

  public syncFormValues() {
    this.mappedField.mappingId = parseInt(this.mappedFieldForm.controls['mapDescription'].value);
    this.mappedField.sinknode = this.mappedFieldForm.controls['sinkNode'].value;
  }

  public close() {
    this._modal.close();
  }
}
